import withPagination from './withPaginationTable';
export default withPagination;
